module.exports = __webpack_public_path__ + "img/benadryl_allergy_dye_free_liqui_gels.d4de5a71.png";